import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

interface SubmitButtonProps {
  label: string;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

export function SubmitButton({ label, className, disabled, isLoading }: SubmitButtonProps) {
  const isInert = disabled || isLoading;
  return (
    <span className={isInert ? 'cursor-no-drop' : undefined}>
      <Button
        type="submit"
        disabled={isInert}
        className={cn(
          'py-5 w-32 sm:w-36 md:w-40 text-data-card-xs font-bold text-white bg-button-save',
          isInert ? 'pointer-events-none' : 'cursor-pointer',
          className,
        )}
      >
        {isLoading ? <Loader2 className="animate-spin" /> : label}
      </Button>
    </span>
  );
}
